import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ConnectionService } from '../../connection.service';

@Component({
	selector: 'app-basic-layout',
	templateUrl: './basic-layout.component.html',
	styleUrls: ['./basic-layout.component.css']
})
export class BasicLayoutComponent implements OnInit {

	href: string = ""; SidebarCollapsed;
	blockDetails: any;
	transactionDetails: any;

	constructor(private router: Router, public connectionService: ConnectionService) { }

	ngOnInit() {
		
	}

}